module.exports = __webpack_public_path__ + "static/media/fly0040.1010516c.webp";